<template>
  <div class="mod-approachs">
    <div class="segment" v-if="selectedProduct">
      <span class="type">
        去程
      </span>
      <span class="org-dst">
        {{ approachs[activeTab]?.depCityName }} ——— {{ approachs[activeTab]?.arrCityName }}
      </span>
    </div>
    <div v-show="!selectedProduct">
      <div class="approachs-head">
        <img class="image" :style="{ 'width': hasOffers ? '280px' : '375px' }" :src="setApproachsHeadImgSrc(hasOffers)" />
      </div>
      <div class="mod-tab">
        <div
          :class="{'tab-item': true, 'selected-item': activeTab === aIndex}"
          v-for="(aItem, aIndex) in approachs"
          :key="aIndex" @click="onTabChange(aIndex)"
        >
          <span>{{ aItem.depCityName }}</span>-<span>{{ aItem.arrCityName }}</span>
          <span class="price"> ￥{{ aItem.price }} 起</span>
          <img v-if="activeTab === aIndex" class="selected-image" :src="selectedImgSrc" />
        </div>
      </div>
      <template v-if="aItinerarys.length">
        <l-filter :segment="{}" :isJJC="isJJC" defaultSelect="priceAsc" type="approachFlight"  @sort="onSort"></l-filter>
        <div
          v-for="(aItinerary, index) in aItinerarys"
          :key="`approach-${aItinerary.orgDsts[0].flightNo}-${aItinerary.orgDsts[0].departureTime}-${index}`"
          v-show="(index <= maxLen - 1) || (index > maxLen - 1 && !showMoreBtn)"
        >
          <!-- NOTE: JD - 公示经济舱 基础运价 及 航班截载时间 -->
          <div v-if="airline === 'JD'" class="mod-info">
            <span v-if="aItinerary.orgDsts?.[0]?.economyPrice" style="margin-right: 30px">{{ `${ aItinerary.orgDsts?.[0]?.airlineName }经济舱全价：${ aItinerary.orgDsts?.[0]?.economyPrice } 元` }}</span>
            <span v-if="aItinerary.orgDsts?.[0]?.cutOffTime">{{ `${ aItinerary.orgDsts?.[0]?.departureAirPortName }航班起飞前 ${ aItinerary.orgDsts?.[0]?.cutOffTime } 分钟停止办理乘机手续` }}</span>
            <span v-else>航班截载时间以机场信息为准</span>
          </div>
          <itinerary
            ref="approachItinerary"
            :itinerary="aItinerary"
            :hasApproachsData="hasApproachsData"
            :isTransfer="aItinerary.isTransfer"
            :index="index"
            :offerItemId="offerItemId"
            :segment="{}"
            :isJJC="isJJC"
            :benefitRules="benefitRules"
            :boutiqueAirlineLabels="boutiqueAirlineLabels"
            :labelPrices="labelPrices"
            :itineraryType="itineraryType"
            @open="onOpen"
            @select="onSelect"
          >
          </itinerary>
        </div>
      </template>
      <div class="mod-more" v-if="approachs[activeTab].itinerarys.length > maxLen && showMoreBtn" @click="showMoreBtn = false">查看更多<l8-icon class="l8-icon" type="icon-xiajiantou"/></div>
    </div>
    <template v-if="selectedProduct">
      <choose
        :itinerary="aItinerarys[openIndex]"
        :product="selectedProduct"
        :isJJC="isJJC"
        :ifInternational="ifInternational"
        :isTransfer="aItinerarys[openIndex]?.isTransfer"
        @cancel="onCancel"
      >
      </choose>
    </template>
    <a-modal
      v-model="validateGoVisible"
      :title="validateGoData.title"
      dialogClass="ant-modal-confirm ant-modal-confirm-confirm"
      :closable="false"
      :footer="null"
      :width="416"
    >
      <div class="ant-modal-confirm-body ant-modal-confirm-body-wrapper">
        <a-icon type="question-circle" />
        <span class="ant-modal-confirm-title">{{ validateGoData.title }}</span>
        <div class="ant-modal-confirm-content" v-html="validateGoData.content"></div>
        <div class="ant-modal-confirm-btns">
          <a-button key="back" @click="() => this.validateGoVisible = false">
            {{ validateGoData.cancelText }}
          </a-button>
          <a
            style="margin-left: 12px;"
            class="ant-btn ant-btn-primary"
            :href="validateGoData.url"
            @click="() => this.validateGoVisible = false"
            target="_blank"
          >
            {{ validateGoData.okText }}
          </a>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import Itinerary from './ItineraryCross'
import Choose from './Choose'
import Filter from './FilterCross'
import '../css/approachs.less'
import Observer from '@/assets/js/observer'
import { validateIsEnable } from '@/apis/flight'
import { MINIO_FRONTEND_STATIC_ROUTE } from '@/assets/js/util'
import { hanleItinerarys, handleTransit, sortItinerarys } from '../util'

const { airline } = window.__MICRO_ROOT__
const selectedImg = `${MINIO_FRONTEND_STATIC_ROUTE}/flight/approachs/checked.png`

export default {
  props: {
    hasOffers: Boolean,
    approachDetail: Object,
    approachFlights: Array,
    currentItineraryIndex: Number,
    selectedProducts: Array,
    ifInternational: Boolean,
    isJJC: Boolean,
    pageCmsData: Object
  },
  data () {
    return {
      // 目前仅查单程临近航班
      offerIndex: 0,
      selectedProduct: null,
      validateGoData: {},
      validateGoVisible: false,
      offerItemId: '',
      sortType: 'priceAsc',
      benefitRules: [],
      labelPrices: [],
      boutiqueAirlineLabels: [],
      airline,
      activeTab: 0,
      aItinerarys: [],
      chooseItinerary: [],
      openIndex: -1,
      showMoreBtn: true,
      selectedImgSrc: selectedImg,
      itineraryType: 'approachFlight',
      maxLen: 3,
      hasApproachsData: true
    }
  },
  async created () {
    this.cmsInit()
  },
  computed: {
    approachDetailItinerarys () {
      const { approachDetail, ifInternational } = this
      if (_.isEmpty(approachDetail)) {
        return []
      }
      return hanleItinerarys(approachDetail, ifInternational)
    },
    approachs () {
      const { approachFlights, sortType, airline } = this
      const _approachFlights = _.cloneDeep(approachFlights)
      _approachFlights.forEach(approach => {
        const { lowestPrices } = approach
        let itinerarys = approach.itinerarys
        approach.price = _.minBy(lowestPrices, product => +product.price)?.price
        itinerarys.forEach(itinerary => {
          itinerary.productLoading = false
          itinerary.cabins = lowestPrices.map(cabin => {
            return itinerary.orgDsts?.[0]?.segmentKey === cabin.segmentKey ? {
              ...cabin,
              cabinLevel: cabin.levelCode,
              cabinName: cabin.levelName,
              disabled: false
            } : null
          }).filter(Boolean)
          // 中转概览
          if (itinerary.orgDsts?.length > 1) {
            Object.assign(itinerary, handleTransit(itinerary))
          }
        })

        // 按sortType进行排序
        sortItinerarys(itinerarys, sortType, airline, 'price')
      })

      return _approachFlights
    }
  },
  watch: {
    approachFlights: {
      deep: true,
      handler: function (newVal) {
        if (newVal) {
          this.activeTab = 0
        }
      }
    },
    approachs: {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        this.aItinerarys = newVal?.[this.activeTab]?.itinerarys || []
      }
    },
    approachDetailItinerarys: {
      deep: true,
      handler: function (list) {
        if (list.length) {
          if (this.aItinerarys?.[this.currentItineraryIndex]) {
            Object.assign(this.aItinerarys[this.currentItineraryIndex], list[0])
            this.aItinerarys[this.currentItineraryIndex].productLoading = false
          } else {
            this.aItinerarys = list
          }
        } else {
          if (this.aItinerarys[this.currentItineraryIndex]?.productLoading) {
            this.aItinerarys[this.currentItineraryIndex].productLoading = false
          }
          this.hasApproachsData = false
        }
      }
    }
  },
  methods: {
    cmsInit () {
      const { pageCmsData } = this
      // 获取cms价格标签配置
      this.labelPrices = _.get(pageCmsData, 'flight-label-price.list') || []
      // 获取cms权益配置
      this.benefitRules = _.get(pageCmsData, 'rights-configs.list') || []
      // 精品航线标识
      this.boutiqueAirlineLabels = _.get(this.pageCmsData, 'flight-boutique-airline-label.flightLabels') ?? []
    },
    setApproachsHeadImgSrc (hasOffers) {
      const imgName = hasOffers ? 'hasFlights' : 'noFlights'
      return `${MINIO_FRONTEND_STATIC_ROUTE}/flight/approachs/${imgName}.png`
    },
    onOpen (data) {
      const { value, index, isSearch, flightInfo = {} } = data
      this.aItinerarys[index].productLoading = isSearch
      this.offerItemId = value
      this.openIndex = index
      if (isSearch) {
        this.$emit('approachSearch',
          { ...flightInfo, type: 'one' },
          this.offerIndex
        )
      }
    },
    onTabChange (index) {
      this.showMoreBtn = true
      this.activeTab = index
      this.approachs.forEach(approach => {
        approach.itinerarys.forEach(itinerary => {
          itinerary.cabins?.forEach(cabin => {
            cabin.checked = false
          })
        })
      })
      this.aItinerarys = this.approachs[index]?.itinerarys || []
    },
    onSelect (product, choose) {
      this.selectedProduct = product
      this.isEnableValidate(product, choose)
    },
    async isEnableValidate (product, choose) {
      const checkProduct = { ...choose, ...product.detail.services[0] }
      const params = {
        argFlightNo: checkProduct.flightNo,
        argCabinCode: checkProduct.cabinCode,
        argDepCode: checkProduct.depCode,
        argArrCode: checkProduct.arrCode,
        argProductCode: checkProduct.productCode,
        argFlightDate: `${checkProduct.departureDate} ${checkProduct.departureTime}`
      }
      validateIsEnable(params).then(() => {
        this.$emit('select', this.offerIndex, choose, product, this.itineraryType)
      }).catch(err => {
        const { code, data } = err

        if (code === '-1' && data && data.length) {
          const observer = new Observer()
          observer.complete = () => {
            this.$emit('select', this.offerIndex, choose, product, this.itineraryType)
          }
          for (const item of data) {
            if (item.code === '100100') {
              // 错误提示
              observer.add(() => {
                this.$error({
                  title: item.title || '温馨提示',
                  okText: item.cancelText || '知道了',
                  content: h => item.message
                })

                return Promise.reject(new Error())
              })

              break
            } else if (item.code === '100200') {
              // 提示，可以进入下一步
              observer.add(() => {
                return new Promise((resolve, reject) => {
                  this.$confirm({
                    title: item.title || '温馨提示',
                    content: h => item.message,
                    okText: item.okText || '继续预订',
                    cancelText: item.cancelText || '知道了',
                    onOk: () => {
                      resolve()
                    },
                    onCancel: () => {
                      reject(new Error())
                    }
                  })
                })
              })
            } else if (item.code === '100300') {
              // 提示，下一步跳转链接
              observer.add(() => {
                this.validateGoData = {
                  title: item.title || '温馨提示',
                  content: item.message,
                  okText: item.okText || '继续预订',
                  cancelText: item.cancelText || '知道了',
                  url: item.url
                }
                this.validateGoVisible = true

                return Promise.reject(new Error())
              })

              break
            } else {
              // 未知类型
              observer.add(() => {
                this.$error({
                  title: item.title || '温馨提示',
                  okText: item.cancelText || '知道了',
                  content: h => item.message
                })

                return Promise.reject(new Error())
              })

              break
            }
          }

          if (observer.queue.length) {
            observer.start()
          }
        } else {
          this.$message.error(err.message || '网络异常，请稍后再试！')
        }
      })
    },
    onCancel () {
      const { offerIndex, ifInternational } = this
      if (!ifInternational) {
        this.selectedProduct = null
        this.$emit('select', offerIndex, null, null, this.itineraryType)
      } else {
        this.$emit('cancelAll')
      }
    },
    onSort (sort) {
      this.sortType = sort
    }
  },
  filters: {},
  components: {
    Itinerary,
    'l-filter': Filter,
    Choose
  }
}
</script>
